import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import {
  validateData,
  addHeader,
  addTitle,
  addEmployeeEmployerInfo,
  addSalaryTable,
  addNetAmountsAndFooter
} from './pdfUtils';

export const generatePDF = (employeeInfo, salaryDetails, employerInfo) => {
  if (!validateData(salaryDetails)) return;

  const doc = new jsPDF();
  addHeader(doc, employeeInfo, salaryDetails, employerInfo);
  addTitle(doc);
  addEmployeeEmployerInfo(doc, employeeInfo, salaryDetails);
  addSalaryTable(doc, salaryDetails);
  addNetAmountsAndFooter(doc, salaryDetails);
  doc.save('bulletin_de_paie.pdf');
};
